<template>
  <div class="list">
    <ul>
      <li v-for="value in list" :key="value.id">
          <button v-on:click="addToList(value.name), selected = value.name" class="add-list"><img src="../assets/images/addList.png" alt="add" />{{value.name}}</button>
          <div :class="{highlight:value.name == selected}"  class="message-add">
            <p>
              <span class="name-user">{{playerName}}</span> {{ $t('notification.add_player_list')}}
            </p>
            <button v-on:click="clean(value.name), selected = ''" class="btn-al">{{ $t('notification.undo')}}</button>
          </div>
      </li>
    </ul>
  </div>
</template>

<script>

import json from '@/assets/data/list.json'
import { bus } from '../main'
import WishList from '../parse/models/WishList'

export default {
  name: 'list',
  props: {
    idPlayer: String,
    lists: Array
  },
  components: {
  },
  data () {
    return {
      disable: true,
      selected: undefined,
      data: json,
      playerName: '',
      list: []
    }
  },
  created(){

    WishList.getList().then((wishList) => {
      this.list = wishList
    })
  },
  methods:{
    cld(){
      this.disable = true
    },
    clean(name){

      const params = {
        playerId: this.idPlayer,
        nameList: name
      }

      //console.log(params)
      WishList.removePlayerList(params)
      .then((user) => console.log(user))
      .catch(error =>  console.log(error))
    },
    
    addToList(name){

      const params = {
        id: this.idPlayer,
        nameList: name
      }

      WishList.addPlayerToList(params)
      .then((user) => console.log(user))
      .catch(error =>  console.log(error))

      this.playerName = localStorage.namePlayer
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .name-user{
    font-style: italic;
    margin-right: 5px;
  }

  .list{
    background: #000;
    color: #fff;
    transition: all 0.5s;
    padding-top: 20px;
    border-top: 1px solid rgb(128, 128, 128);
  }

  ul {
    overflow: hidden;
  }

  ul li{
    border-bottom: 1px solid rgb(32, 32, 32);
  }

  .add-list{
    background-color: transparent;
    border: none;
    color: #fff;
    margin: 8px 0;
    text-decoration: underline;
    opacity: 0.8;
  }

  .add-list:hover{
    text-decoration: none;
    opacity: 1;
  }

  .add-list img{
    width: 25px;
    margin-right: 10px;
  }

  .btn-al{
    background: #000;
    color: #fff;
    border: none;
    text-decoration: underline;
    font-family: 'plain regular', arial;
  }

  .message-add{
    float: right;
    padding: 10px;
    display: none;
    transition: all 0.5s;
  }

  .message-add p{
    display: inline-block;
  }

  .highlight{
    display: block;
  }

</style>
